<template>
    <ul  class="tags-list" >
       <li v-for="(tag, index) in tags" :key="index">
           <a href @click.prevent="handleClick(tag.id)" :class="itemClass(tag.id)">{{ tag.title }}</a>
       </li>
    </ul>
</template>

<script>
    export default {
        name: 'tag-list',
        props: ['tags', 'activeTags'],
        methods: {
            itemClass(id){
                return this.activeTags.includes(id) ? 'active' : '';
            },
            handleClick(id) {
                this.$emit('click', id);
                this.$router.push({query: {tag: this.activeTags}})
            }
        }
    }
</script>

<style scoped>

</style>
